import React from 'react';

import upperFirst from 'lodash/upperFirst';
import { useTranslation } from 'react-i18next';

import { NumberStatusChip } from '@packages/fenrir/components';

import { getScannerColor } from './get-scanner-appearance';

type ScannerBadgeProps = {
  value: string;
  title?: string;
  size?: 'small' | 'medium';
};

export const ScannerBadge = React.forwardRef<HTMLDivElement, ScannerBadgeProps>(
  ({ value, title, size = 'medium' }, ref) => {
    const { t } = useTranslation('telemetryScanners', { keyPrefix: 'badge' });
    const statusColor = getScannerColor(value);

    return (
      <NumberStatusChip
        hideIcon
        size={size}
        value={title || t(value, upperFirst(value))}
        status={statusColor}
      />
    );
  },
);
